<template>
  <div>
    <Menu
      mode="horizontal"
      accordion
      class="menu-bar"
      @on-select="onMenuClick"
    >
      <Submenu
        name="file"
        class="submenu"
      >
        <template slot="title">
          File
        </template>
        <MenuItem
          name="newTab"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="far fa-file" />
            </div>
            <div class="description">
              New Query
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="newFolder"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-folder-plus" />
            </div>
            <div class="description">
              New Folder
            </div>
          </div>
        </MenuItem>
        <div class="separator" />
        <MenuItem
          name="save"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="far fa-save" />
            </div>
            <div class="description">
              Save
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+S</span>
              <span v-else>⌘S</span>
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="saveAs"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon" />
            <div class="description">
              Save As
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="saveToRepo"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fab fa-google-drive" />
            </div>
            <div class="description">
              Save to Query Repository
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="saveAll"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon" />
            <div class="description">
              Save All
            </div>
          </div>
        </MenuItem>
        <div class="separator" />
        <MenuItem
          name="closeQuery"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon" />
            <div class="description">
              Close Current Query
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="closeOthers"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon" />
            <div class="description">
              Close Others
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="closeSaved"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon" />
            <div class="description">
              Close Saved Queries
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="closeAll"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon" />
            <div class="description">
              Close All Queries
            </div>
          </div>
        </MenuItem>
        <div class="separator" />
        <MenuItem
          name="removeFile"
          class="menu-item"
          :class="{ 'disabled': !selectedFileNode.isLeaf }"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-trash-alt" />
            </div>
            <div class="description">
              Delete Query
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="removeFolder"
          class="menu-item"
          :class="{ 'disabled': selectedFileNode.isLeaf || selectedFileNode.folderPath === '/' }"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-folder-minus" />
            </div>
            <div class="description">
              Delete Folder
            </div>
          </div>
        </MenuItem>
        <div class="separator" />
        <Submenu
          name="queryResults"
          class="inner-submenu"
        >
          <template slot="title">
            <div class="menu-item-block">
              <div class="icon">
                <i class="fas fa-list-ul" />
              </div>
              <div class="description">
                Export Results
              </div>
            </div>
          </template>
          <MenuItem
            name="copyResult"
            class="menu-item"
            :class="{ 'disabled': disabledItem }"
          >
            <div class="menu-item-block">
              <div class="icon">
                <i class="far fa-copy" />
              </div>
              <div class="description">
                Copy Current Result Batch
              </div>
            </div>
          </MenuItem>
          <MenuItem
            name="downloadAllData"
            class="menu-item"
            :class="{ 'disabled': disabledItem }"
          >
            <div class="menu-item-block">
              <div class="icon">
                <i class="fas fa-download" />
              </div>
              <div class="description">
                Download Result
              </div>
            </div>
          </MenuItem>
          <div class="separator" />
          <MenuItem
            name="googleSheet"
            class="menu-item"
            :class="{ 'disabled': disabledItem }"
          >
            <div class="menu-item-block">
              <div class="icon">
                <i class="fab fa-google-drive" />
              </div>
              <div class="description">
                Export to Google Sheets
              </div>
            </div>
          </MenuItem>
          <MenuItem
            name="googleScript"
            class="menu-item"
            :class="{ 'disabled': disabledItem }"
          >
            <div class="menu-item-block">
              <div class="icon">
                <i class="fas fa-terminal" />
              </div>
              <div class="description">
                Export via Google Apps Script
              </div>
            </div>
          </MenuItem>
          <div class="separator" />
          <MenuItem
            name="exportEmail"
            class="menu-item"
            :class="{ 'disabled': disabledItem }"
          >
            <div class="menu-item-block">
              <div class="icon">
                <i class="fas fa-envelope" />
              </div>
              <div class="description">
                Send to Email
              </div>
            </div>
          </MenuItem>
        </Submenu>
      </Submenu>
      <Submenu
        name="edit"
        class="submenu"
      >
        <template slot="title">
          Edit
        </template>
        <MenuItem
          name="undo"
          class="menu-item"
          :class="{ 'disabled': !currentTab.undoIndex }"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-undo" />
            </div>
            <div class="description">
              Undo
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+Z</span>
              <span v-else>⌘Z</span>
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="redo"
          class="menu-item"
          :class="{ 'disabled': !currentTab.redoIndex }"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-redo" />
            </div>
            <div class="description">
              Redo
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+Y</span>
              <span v-else>⌘Y</span>
            </div>
          </div>
        </MenuItem>
        <div class="separator" />
        <MenuItem
          name="cut"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-cut" />
            </div>
            <div class="description">
              Cut
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+X</span>
              <span v-else>⌘X</span>
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="copy"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="far fa-clone" />
            </div>
            <div class="description">
              Copy
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+C</span>
              <span v-else>⌘C</span>
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="paste"
          class="menu-item"
          :class="{ 'disabled': !clipboardData }"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="far fa-clipboard" />
            </div>
            <div class="description">
              Paste
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+V</span>
              <span v-else>⌘V</span>
            </div>
          </div>
        </MenuItem>
        <div class="separator" />
        <MenuItem
          name="find"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-binoculars" />
            </div>
            <div class="description">
              Find
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+F</span>
              <span v-else>⌘F</span>
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="findNext"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon" />
            <div class="description">
              Find Next
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+G</span>
              <span v-else>⌘G</span>
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="findPrev"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon" />
            <div class="description">
              Find Previous
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+Shift+G</span>
              <span v-else>⇧⌘G</span>
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="replace"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-random" />
            </div>
            <div class="description">
              Replace
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+Shift+F</span>
              <span v-else>⌥⌘F</span>
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="replaceAll"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon" />
            <div class="description">
              Replace All
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+Shift+R</span>
              <span v-else>⌥⇧⌘F</span>
            </div>
          </div>
        </MenuItem>
        <div class="separator" />
        <MenuItem
          name="indent"
          class="menu-item"
          :class="{ 'disabled': !currentTab.editorText }"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-stream" />
            </div>
            <div class="description">
              Format Query
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+I</span>
              <span v-else>⌘I</span>
            </div>
          </div>
        </MenuItem><div class="separator" />
        <MenuItem
          name="drawPolygon"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-globe" />
            </div>
            <div class="description">
              Geo mapping wizard
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+W</span>
              <span v-else>⌘W</span>
            </div>
          </div>
        </MenuItem>
      </Submenu>
      <Submenu
        name="view"
        class="submenu"
      >
        <template slot="title">
          View
        </template>
        <MenuItem
          name="toolbar"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i
                v-show="showToolBar"
                class="fas fa-check"
              />
            </div>
            <div class="description">
              Show Toolbar
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="panel"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i
                v-show="showActionPanel"
                class="fas fa-check"
              />
            </div>
            <div class="description">
              Show Navigator
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="lint"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i
                v-show="showLint"
                class="fas fa-check"
              />
            </div>
            <div class="description">
              Show SQL Lint
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="hints"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i
                v-show="showHints"
                class="fas fa-check"
              />
            </div>
            <div class="description">
              Autocomplete
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+E</span>
              <span v-else>⌘E</span>
            </div>
          </div>
        </MenuItem>
        <div class="separator" />
        <Submenu
          name="themes"
          class="inner-submenu"
        >
          <template slot="title">
            <div class="menu-item-block">
              <div class="icon">
                <i class="fas fa-palette" />
              </div>
              <div class="description">
                Themes
              </div>
            </div>
          </template>
          <MenuGroup title="Light">
            <MenuItem
              name="theme-default"
              class="menu-item"
            >
              <div class="menu-item-block">
                <div class="icon">
                  <i
                    v-show="theme === 'default'"
                    class="fas fa-check"
                  />
                </div>
                <div class="description">
                  Default
                </div>
              </div>
            </MenuItem>
            <MenuItem
              name="theme-duotone-light"
              class="menu-item"
            >
              <div class="menu-item-block">
                <div class="icon">
                  <i
                    v-show="theme === 'duotone-light'"
                    class="fas fa-check"
                  />
                </div>
                <div class="description">
                  Duotone Light
                </div>
              </div>
            </MenuItem>
            <MenuItem
              name="theme-elegant"
              class="menu-item"
            >
              <div class="menu-item-block">
                <div class="icon">
                  <i
                    v-show="theme === 'elegant'"
                    class="fas fa-check"
                  />
                </div>
                <div class="description">
                  Elegant
                </div>
              </div>
            </MenuItem>
            <MenuItem
              name="theme-mdn-like"
              class="menu-item"
            >
              <div class="menu-item-block">
                <div class="icon">
                  <i
                    v-show="theme === 'mdn-like'"
                    class="fas fa-check"
                  />
                </div>
                <div class="description">
                  MDN Like
                </div>
              </div>
            </MenuItem>
            <MenuItem
              name="theme-neat"
              class="menu-item"
            >
              <div class="menu-item-block">
                <div class="icon">
                  <i
                    v-show="theme === 'neat'"
                    class="fas fa-check"
                  />
                </div>
                <div class="description">
                  Neat
                </div>
              </div>
            </MenuItem>
          </MenuGroup>
          <div class="separator" />
          <MenuGroup title="Dark">
            <MenuItem
              name="theme-abcdef"
              class="menu-item"
            >
              <div class="menu-item-block">
                <div class="icon">
                  <i
                    v-show="theme === 'abcdef'"
                    class="fas fa-check"
                  />
                </div>
                <div class="description">
                  Abcdef
                </div>
              </div>
            </MenuItem>
            <MenuItem
              name="theme-blackboard"
              class="menu-item"
            >
              <div class="menu-item-block">
                <div class="icon">
                  <i
                    v-show="theme === 'blackboard'"
                    class="fas fa-check"
                  />
                </div>
                <div class="description">
                  Blackboard
                </div>
              </div>
            </MenuItem>
            <MenuItem
              name="theme-cobalt"
              class="menu-item"
            >
              <div class="menu-item-block">
                <div class="icon">
                  <i
                    v-show="theme === 'cobalt'"
                    class="fas fa-check"
                  />
                </div>
                <div class="description">
                  Cobalt
                </div>
              </div>
            </MenuItem>
            <MenuItem
              name="theme-colorforth"
              class="menu-item"
            >
              <div class="menu-item-block">
                <div class="icon">
                  <i
                    v-show="theme === 'colorforth'"
                    class="fas fa-check"
                  />
                </div>
                <div class="description">
                  Colorforth
                </div>
              </div>
            </MenuItem>
            <MenuItem
              name="theme-dracula"
              class="menu-item"
            >
              <div class="menu-item-block">
                <div class="icon">
                  <i
                    v-show="theme === 'dracula'"
                    class="fas fa-check"
                  />
                </div>
                <div class="description">
                  Dracula
                </div>
              </div>
            </MenuItem>
            <MenuItem
              name="theme-mbo"
              class="menu-item"
            >
              <div class="menu-item-block">
                <div class="icon">
                  <i
                    v-show="theme === 'mbo'"
                    class="fas fa-check"
                  />
                </div>
                <div class="description">
                  MBO
                </div>
              </div>
            </MenuItem>
            <MenuItem
              name="theme-midnight"
              class="menu-item"
            >
              <div class="menu-item-block">
                <div class="icon">
                  <i
                    v-show="theme === 'midnight'"
                    class="fas fa-check"
                  />
                </div>
                <div class="description">
                  Midnight
                </div>
              </div>
            </MenuItem>
            <MenuItem
              name="theme-twilight"
              class="menu-item"
            >
              <div class="menu-item-block">
                <div class="icon">
                  <i
                    v-show="theme === 'twilight'"
                    class="fas fa-check"
                  />
                </div>
                <div class="description">
                  Twilight
                </div>
              </div>
            </MenuItem>
          </MenuGroup>
        </Submenu>
      </Submenu>
      <Submenu
        name="actions"
        class="submenu"
      >
        <template slot="title">
          Actions
        </template>
        <MenuItem
          name="run"
          class="menu-item"
          :class="{ 'disabled': !currentTab.editorText }"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-play" />
            </div>
            <div class="description">
              Run Query
            </div>
            <div class="command">
              <span v-if="!isMacOS">Ctrl+Return</span>
              <span v-else>⌘+Return</span>
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="cancel"
          class="menu-item"
          :class="{ 'disabled': !currentTab.isQueryRunning }"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-stop" />
            </div>
            <div class="description">
              Cancel Query
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="sqlLint"
          class="menu-item"
          :class="{ 'disabled': !currentTab.editorText }"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-notes-medical" />
            </div>
            <div class="description">
              Validate Query
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="schedule"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-clock" />
            </div>
            <div class="description">
              Schedule Query
            </div>
          </div>
        </MenuItem>
        <MenuItem
          name="nominate"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-hat-wizard" />
            </div>
            <div class="description">
              Nominate To Golden Query
            </div>
          </div>
        </MenuItem>
        <div class="separator" />
        <MenuItem
          name="share"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="fas fa-share-alt" />
            </div>
            <div class="description">
              Share Query
            </div>
          </div>
        </MenuItem>
        <div class="separator" />
        <MenuItem
          name="snowflake"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <Icon
                type="custom-snowflake"
                size="16"
              />
            </div>
            <div class="description">
              Change Snowflake Credentials
            </div>
          </div>
        </MenuItem>
      </Submenu>
      <Submenu
        name="help"
        class="submenu"
      >
        <template slot="title">
          Help
        </template>
        <MenuItem
          name="feedback"
          class="menu-item"
        >
          <div class="menu-item-block">
            <div class="icon">
              <i class="far fa-envelope" />
            </div>
            <div class="description">
              Contact us...
            </div>
          </div>
        </MenuItem>
      </Submenu>
    </Menu>

    <div
      v-show="showToolBar"
      class="toolbar"
    >
      <Tooltip
        content="New Query"
        placement="top"
        class="toolbar-icon"
        @click.native="onMenuClick('newTab')"
      >
        <i class="far fa-file" />
      </Tooltip>
      <Tooltip
        content="New Folder"
        placement="top"
        class="toolbar-icon"
        @click.native="onMenuClick('newFolder')"
      >
        <i class="fas fa-folder-plus" />
      </Tooltip>
      <Tooltip
        content="Save Query"
        placement="top"
        class="toolbar-icon"
        @click.native="onMenuClick('save')"
      >
        <i class="far fa-save" />
      </Tooltip>
      <Tooltip
        content="Delete Query"
        placement="top"
        class="toolbar-icon"
        @click.native="selectedFileNode.isLeaf && onMenuClick('removeFile')"
      >
        <i
          class="fas fa-trash-alt"
          :class="{ 'disabled': !selectedFileNode.isLeaf }"
        />
      </Tooltip>
      <Tooltip
        content="Delete Folder"
        placement="top"
        class="toolbar-icon"
        @click.native="!selectedFileNode.isLeaf && selectedFileNode.folderPath !== '/' && onMenuClick('removeFolder')"
      >
        <i
          class="fas fa-folder-minus"
          :class="{ 'disabled': selectedFileNode.isLeaf || selectedFileNode.folderPath === '/' }"
        />
      </Tooltip>
      <div class="separator" />
      <Tooltip
        content="Undo"
        placement="top"
        class="toolbar-icon"
        @click.native="currentTab.undoIndex && onMenuClick('undo')"
      >
        <i
          class="fas fa-undo"
          :class="{ 'disabled': !currentTab.undoIndex }"
        />
      </Tooltip>
      <Tooltip
        content="Redo"
        placement="top"
        class="toolbar-icon"
        @click.native="currentTab.redoIndex && onMenuClick('redo')"
      >
        <i
          class="fas fa-redo"
          :class="{ 'disabled': !currentTab.redoIndex }"
        />
      </Tooltip>
      <div class="separator" />
      <Tooltip
        content="Cut"
        placement="top"
        class="toolbar-icon"
        @click.native="onMenuClick('cut')"
      >
        <i class="fas fa-cut" />
      </Tooltip>
      <Tooltip
        content="Copy"
        placement="top"
        class="toolbar-icon"
        @click.native="onMenuClick('copy')"
      >
        <i class="far fa-clone" />
      </Tooltip>
      <Tooltip
        content="Paste"
        placement="top"
        class="toolbar-icon"
        @click.native="clipboardData && onMenuClick('paste')"
      >
        <i
          class="far fa-clipboard"
          :class="{ 'disabled': !clipboardData }"
        />
      </Tooltip>
      <div class="separator" />
      <Tooltip
        content="Find"
        placement="top"
        class="toolbar-icon"
        @click.native="onMenuClick('find')"
      >
        <i class="fas fa-binoculars" />
      </Tooltip>
      <Tooltip
        content="Replace"
        placement="top"
        class="toolbar-icon"
        @click.native="onMenuClick('replace')"
      >
        <i class="fas fa-random" />
      </Tooltip>
      <div class="separator" />
      <Tooltip
        content="Share Query"
        placement="top"
        class="toolbar-icon"
        @click.native="onMenuClick('share')"
      >
        <i
          class="fas fa-share-alt"
          :class="{ 'disabled': false }"
        />
      </Tooltip>
      <Tooltip
        content="Share Query Result"
        placement="top"
        class="toolbar-icon"
        @click.native="onMenuClick('shareResult')"
      >
        <i class="fas fa-share-square" />
      </Tooltip>
      <template v-if="currentTab.sharedResultLinks && currentTab.sharedResultLinks.length > 0">
        <Dropdown
          trigger="hover"
          class="shared-results-dropdown"
          @on-click="onMenuClick('sharedLinkSelect', arguments[0])"
        >
          <i class="shared-results-dropdown-icon fas fa-caret-down" />
          <DropdownMenu slot="list">
            <DropdownItem
              v-for="(link, index) in currentTab.sharedResultLinks"
              :key="index"
              :name="link.link"
            >
              {{ link.created }}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </template>
      <div class="separator" />
      <Tooltip
        content="Nominate To Golden Query"
        placement="top"
        class="toolbar-icon"
        @click.native="onMenuClick('nominate')"
      >
        <i class="fas fa-hat-wizard" />
      </Tooltip>
      <Tooltip
        content="Validate Query"
        placement="top"
        class="toolbar-icon"
        @click.native="onMenuClick('sqlLint')"
      >
        <i class="fas fa-notes-medical" />
      </Tooltip>
      <Tooltip
        content="Run Query"
        placement="top"
        class="toolbar-icon"
        @click.native="currentTab.editorText && onMenuClick('run')"
      >
        <i
          class="fas fa-play"
          :class="{ 'disabled': !currentTab.editorText }"
        />
      </Tooltip>
      <Tooltip
        content="Cancel Query"
        placement="top"
        class="toolbar-icon"
        @click.native="currentTab.isQueryRunning && onMenuClick('cancel')"
      >
        <i
          class="fas fa-stop"
          :class="{ 'disabled': !currentTab.isQueryRunning }"
        />
      </Tooltip>
      <Tooltip
        content="Schedule Query"
        placement="top"
        class="toolbar-icon"
        @click.native="onMenuClick('schedule')"
      >
        <i class="fas fa-clock" />
      </Tooltip>
      <div class="separator" />
      <Tooltip
        content="Copy Current Result Batch"
        placement="top"
        class="toolbar-icon"
        @click.native="!disabledItem && onMenuClick('copyResult')"
      >
        <i
          class="far fa-copy"
          :class="{ 'disabled': disabledItem }"
        />
      </Tooltip>
      <div class="separator" />
      <Tooltip
        content="Geo Mapping Wizard"
        placement="top"
        class="toolbar-icon"
        @click.native="onMenuClick('drawPolygon')"
      >
        <i
          class="fas fa-globe"
        />
      </Tooltip>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
  props: {
    currentTab: Object,
    clipboardData: String,
    showToolBar: Boolean,
    showActionPanel: Boolean,
    showLint: Boolean,
    showHints: Boolean,
    theme: String
  },

  data () {
    return {
      isMacOS: false
    }
  },

  computed: {
    disabledItem () {
      return !this.currentTab.hasQueryRun || !this.currentTab.results.length || _.has(this.currentTab.results[0], 'error')
    },

    ...mapState('queryPad', {
      selectedFileNode: state => state.selectedFileNode || {}
    })
  },

  created () {
    const appVersion = window.navigator.appVersion
    this.isMacOS = appVersion.indexOf('Mac') !== -1
  },

  methods: {
    /**
     * Executes an action depending of the menu option selected.
     * @param {String} option
     */
    onMenuClick (option, value) {
      this.$emit('menuClick', option, value)
    }
  }
}
</script>

<style scoped>
  .menu-bar {
    margin: 0;
    padding: 8px;
    height: 40px;
    background-color: var(--color-light-gray);
    border-left: 1px solid var(--color-gray-border);
    border-right: 1px solid var(--color-gray-border);
    display: flex;
    flex-direction: row;
    align-items: center;
    user-select: none;
  }
  .menu-bar .submenu {
    margin: 0;
    padding: 4px 8px;
    color: var(--color-black);
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: none;
    line-height: initial;
    position: relative;
  }
  .menu-bar .submenu >>> .ivu-menu-submenu-title {
    margin: 0;
    padding: 0;
    height: auto;
    display: flex;
    align-items: center;
    line-height: initial;
  }
  .menu-bar .submenu >>> .ivu-menu-submenu-title .ivu-icon {
    margin: 0;
    margin-left: 8px;
  }
  .menu-bar .submenu:hover {
    color: var(--color-black);
    border-bottom: none;
    background-color: var(--color-gray-border);
  }
  .menu-bar .submenu >>> .ivu-select-dropdown {
    top: 26px !important;
    left: -8px !important;
    overflow: inherit;
  }
  .menu-bar .submenu .separator {
    margin: 8px 0;
    margin-left: 40px;
    width: calc(100% - 40px);
    height: 1px;
    border-top: 1px solid var(--color-gray-border);
  }
  .menu-bar .submenu .menu-item,
  .menu-bar .submenu .menu-item:hover,
  .menu-bar .submenu .inner-submenu .menu-item,
  .menu-bar .submenu .inner-submenu .menu-item:hover {
    margin: 0;
    padding: 8px 16px;
    width: 240px;
    height: auto;
    border: none;
    color: var(--color-black);
    float: unset;
    box-sizing: content-box;
  }
  .menu-bar .submenu .menu-item:hover {
    background-color: var(--color-gray-hover);
  }
  .menu-bar .submenu .menu-item >>> .ivu-select-dropdown {
    margin: 0;
    padding: 0;
    top: 8px !important;
    left: 0 !important;
    box-shadow: none;
    position: relative !important;
    height: auto;
  }
  .menu-bar .submenu >>> .ivu-select-dropdown .ivu-menu-item-group-title {
    color: var(--color-black);
    font-weight: bold;
    font-size: 14px;
  }
  .menu-bar .submenu .menu-item .menu-item {
    padding: 8px;
    width: calc(100% - 32px);
  }
  .menu-bar .submenu .menu-item .separator {
    width: 100%;
    margin-left: 0;
  }
  .menu-bar .submenu .menu-item .menu-item-block,
  .menu-bar .submenu .inner-submenu .menu-item-block {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .menu-bar .submenu .menu-item .menu-item-block .icon,
  .menu-bar .submenu .inner-submenu .menu-item-block .icon {
    max-width: 16px;
    min-width: 16px;
    height: 16px;
    margin-right: 8px;
  }
  .menu-bar .submenu .menu-item .menu-item-block .icon i,
  .menu-bar .submenu .inner-submenu .menu-item-block .icon i {
    padding: 0;
    width: 16px;
    display: inline-block;
    font-size: 14px;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
    text-rendering: auto;
    text-align: center;
    line-height: 1;
    vertical-align: middle;
    color: var(--color-black);
  }
  .menu-bar .submenu .menu-item .menu-item-block .icon i.fa-check {
    font-size: 12px;
  }
  .menu-bar .submenu .menu-item .menu-item-block .description,
  .menu-bar .submenu .inner-submenu .menu-item-block .description {
    width: 100%;
  }
  .menu-bar .submenu .menu-item .menu-item-block .command {
    width: auto;
    color: var(--color-mid-gray);
    text-align: right;
    font-weight: bold;
  }
  .menu-bar .submenu .menu-item.disabled,
  .menu-bar .submenu .menu-item.disabled .menu-item-block .description,
  .menu-bar .submenu .menu-item.disabled .menu-item-block .command,
  .menu-bar .submenu .menu-item.disabled .menu-item-block .icon i {
    pointer-events: none;
    color: var(--color-gray-border);
    cursor: not-allowed;
  }
  .menu-bar .submenu >>> .ivu-select-dropdown > ul {
    list-style-type: none;
  }
  .menu-bar .submenu .inner-submenu {
    width: 100%;
    padding: 8px 16px;
    float: unset;
    color: var(--color-black);
    border-bottom: none;
  }
  .menu-bar .submenu .inner-submenu:hover {
    background-color: var(--color-gray-hover);
  }
  .menu-bar .submenu >>> .inner-submenu.ivu-menu-opened > * > .ivu-menu-submenu-title-icon {
    transform: rotate(-90deg);
  }
  .menu-bar .submenu .inner-submenu >>> .ivu-menu-submenu-title {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .menu-bar .submenu .inner-submenu >>> .ivu-select-dropdown {
    top: 0 !important;
    left: 100% !important;
    margin: 0;
    padding: 0;
  }
  .menu-bar .submenu .inner-submenu .menu-item {
    width: 100%;
    margin: 0;
    padding: 8px 16px;
    left: 0;
  }
  .menu-bar .submenu >>> .ivu-menu-item-active,
  .menu-bar .submenu >>> .ivu-menu-item:hover,
  .menu-bar .submenu >>> .ivu-menu-submenu-active,
  .menu-bar .submenu >>> .ivu-menu-submenu:hover {
    color: var(--color-black);
    border-bottom: none;
  }

  .toolbar {
    margin: 0;
    padding: 8px;
    height: 30px;
    background-color: var(--color-light-gray);
    border: 1px solid var(--color-gray-border);
    border-top: none;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .toolbar .toolbar-icon {
    padding: 0 4px;
    width: 32px;
    height: 16px;
    font-size: 16px;
    display: flex;
    justify-content: center;
  }

  .toolbar .toolbar-icon i {
    cursor: pointer;
    display: flex;
    justify-content: center;
  }

  .disabled {
    pointer-events: none;
    color: var(--color-gray-border);
    cursor: not-allowed;
  }

  .separator {
    margin: 0 8px;
    border-right: 1px solid var(--color-gray-border);
    height: 24px;
  }

  .shared-results-dropdown-icon {
    cursor: pointer;
  }

  .shared-results-dropdown >>> .ivu-select-dropdown {
    max-height: 300px;
    overflow: auto;
  }
</style>
